import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { getItemWebStorage } from "../webStorageSaver";

type ServiceId = 'weatherStations';

type AuthSlice = {
    tokens: {
        app?: string;
        services: Partial<Record<ServiceId, string>>;
    };
};

function getInitialState() {
    const initialState: AuthSlice = {
        tokens: getItemWebStorage('authTokens') ?? {},
    }
    return initialState
}

export const logout = createAction('auth/logout')

const authSlice = createSlice({
    name: 'auth',
    initialState: getInitialState(),
    reducers: {
        setAppAuthToken: (state, action: PayloadAction<string | undefined>) => {
            state.tokens.app = action.payload
        },
        setServiceAuthToken: (state, action: PayloadAction<{ serviceId: ServiceId, token?: string }>) => {
            const { serviceId, token } = action.payload;
            if (!state.tokens.services) state.tokens.services = {};
            state.tokens.services[serviceId] = token;
        },
        setAuthTokens: (state, action: PayloadAction<any>) => {
            state.tokens = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setAppAuthToken, setServiceAuthToken, setAuthTokens } = authSlice.actions

export const authReducer = authSlice.reducer;